import { useDispatch, useSelector } from "react-redux";
import { MuiIconButton } from "..";
import { ReactComponent as HamburgerCloseIcon } from "../../assets/images/hamburger-close.svg";
import { ReactComponent as HamburgerMenuIcon } from "../../assets/images/hamburger-menu.svg";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";
import { sidebarSelector } from "../../redux/slices/appState/appStateSelector";
import { toggleSideBar } from "../../redux/slices/appState/appStateSlice";

export const HamburgerMenuOpenCloseIcon = () => {
  const { commonARIALabel } = useNavigationSiteCore();
  const dispatch = useDispatch();
  const { isOpen } = useSelector(sidebarSelector);

  const handleHamburgerClick = () => {
    dispatch(toggleSideBar({ isOpen: !isOpen }));
  };
  const RenderIcon = isOpen ? HamburgerCloseIcon : HamburgerMenuIcon;
  return (
    <MuiIconButton onClick={handleHamburgerClick}>
      <RenderIcon
        aria-label={
          isOpen
            ? commonARIALabel.openNavigationMenu
            : commonARIALabel.closeNavigationMenu
        }
        className="notificationIcon"
      />
    </MuiIconButton>
  );
};
